import { render, staticRenderFns } from "./THGTagsList.vue?vue&type=template&id=7b3f372c"
import script from "./THGTagsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTagsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports